import { LoadingContainer } from "./loading";

function createLoadingContainer(opt) {
  return new LoadingContainer(opt);
}

export const loadingContainer = createLoadingContainer();
